import * as v3 from './v3/transport';
import * as v5 from './v5/transport';

const impl = process.env.NODE_CONFIG?.backend?.version === 'v5' ? v5 : v3;

export const { authHeader, resolveUrl, prepareConfig } = impl;
